import React from 'react';
import PropTypes from 'prop-types';
import Row from '../row';
import Col from '../col';
import './style';

const propTypes = {
  children: PropTypes.node.isRequired,
};

function StatsWidget({ children }) {
  const childrenCount = React.Children.count(children);
  const layout = {
    xs: 24,
    sm: Math.floor(24 / Math.floor(childrenCount / 2)),
    md: Math.floor(24 / childrenCount),
  };

  const determineClassName = (childCount) => {
    if (childCount === 6) return 'bsa-stats-widget__section bsa-stats-widget__section--six';
    if (childCount === 5) return 'bsa-stats-widget__section bsa-stats-widget__section--five';
    if (childCount === 3) return 'bsa-stats-widget__section bsa-stats-widget__section--three';
    if (childCount % 2 === 0) return 'bsa-stats-widget__section bsa-stats-widget__section--evens';
    return 'bsa-stats-widget__section';
  };

  return (
    <Row className="bsa-stats-widget" type="flex" align="middle" justify="center">
      {
        React.Children.map(children, (item, idx) =>
          (
            <Col key={idx} {...layout} className={determineClassName(childrenCount)}>
              {item}
            </Col>
          ))
      }
    </Row>
  );
}

StatsWidget.propTypes = propTypes;
export default StatsWidget;
